document.querySelectorAll('.ag-filters').forEach(group=>{group.addEventListener('click',event=>{const button=event.target.closest('[data-ag-filter]');if(!button)return;group.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));const filter=button.dataset.agFilter;group.closest('.ag-collection').querySelectorAll('[data-ag-series]').forEach(card=>{card.hidden=filter!=='all'&&card.dataset.agSeries!==filter})})});
(()=>{
  const targets=new Set(['gift-collection','gift-packaging','gift-inside']);
  const jump=(id,focus=false)=>{
    const target=document.getElementById(id);
    if(!target||!targets.has(id))return false;
    const header=document.querySelector('sticky-header');
    const offset=(header?header.getBoundingClientRect().height:0)+16;
    const top=Math.max(0,window.scrollY+target.getBoundingClientRect().top-offset);
    window.scrollTo({top,behavior:'instant'});
    if(focus){target.setAttribute('tabindex','-1');target.focus({preventScroll:true})}
    return true;
  };
  document.addEventListener('click',event=>{
    if(event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    const link=event.target.closest('a[href]');
    if(!link||link.target==='_blank'||link.hasAttribute('download'))return;
    const url=new URL(link.href,location.href);
    const id=url.hash.slice(1);
    if(url.origin!==location.origin||url.pathname!==location.pathname||url.search!==location.search||!targets.has(id)||!document.getElementById(id))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(location.hash!==url.hash)history.pushState(null,'',url.hash);
    jump(id,true);
  },true);
  const restore=()=>jump(location.hash.slice(1));
  if(document.readyState==='complete')restore();else window.addEventListener('load',restore,{once:true});
  window.addEventListener('hashchange',restore);
})();

document.addEventListener('click',event=>{
 const button=event.target.closest('[data-ag-quantity]');
 if(!button)return;
 const input=button.closest('.ag-quantity')?.querySelector('input[name="quantity"]');
 if(!input)return;
 const next=Math.max(Number(input.min)||1,(Number(input.value)||1)+Number(button.dataset.agQuantity));
 input.value=String(next);
 input.dispatchEvent(new Event('input',{bubbles:true}));
 input.dispatchEvent(new Event('change',{bubbles:true}));
});

document.addEventListener('click',event=>{
 const button=event.target.closest('[data-ag-image]');
 if(!button)return;
 const gallery=button.closest('[data-ag-gallery]');
 const image=gallery?.querySelector('.ag-gallery-main img');
 if(!image)return;
 image.removeAttribute('srcset');
 image.src=button.dataset.agImage;
 image.alt=button.dataset.agImageAlt;
 gallery.querySelectorAll('[data-ag-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
});

document.addEventListener('click',event=>{
 const arrow=event.target.closest('[data-ag-gallery-step]');
 if(!arrow)return;
 const gallery=arrow.closest('[data-ag-gallery]');
 const thumbs=Array.from(gallery.querySelectorAll('[data-ag-image]'));
 if(!thumbs.length)return;
 const current=Math.max(0,thumbs.findIndex(item=>item.getAttribute('aria-pressed')==='true'));
 const next=(current+Number(arrow.dataset.agGalleryStep)+thumbs.length)%thumbs.length;
 thumbs[next].click();
 const strip=gallery.querySelector('.ag-gallery-thumbs');
 const thumb=thumbs[next];
 if(thumb.offsetLeft<strip.scrollLeft)strip.scrollTo({left:thumb.offsetLeft,behavior:'smooth'});
 else if(thumb.offsetLeft+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:thumb.offsetLeft+thumb.offsetWidth-strip.clientWidth,behavior:'smooth'});
});

(()=>{
 const mobile=()=>window.matchMedia('(max-width: 989px)').matches;
 document.querySelectorAll('[data-ag-gallery]').forEach(gallery=>{
  const main=gallery.querySelector('.ag-gallery-main');
  let start=null;
  main.addEventListener('touchstart',event=>{start=mobile()&&event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null},{passive:true});
  main.addEventListener('touchmove',event=>{if(event.touches.length!==1)start=null},{passive:true});
  main.addEventListener('touchcancel',()=>{start=null},{passive:true});
  main.addEventListener('touchend',event=>{
   if(!start||!mobile())return;
   const point=event.changedTouches[0],dx=point.clientX-start.x,dy=point.clientY-start.y;
   start=null;
   if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4)gallery.querySelector(`[data-ag-gallery-step="${dx<0?1:-1}"]`)?.click();
  },{passive:true});
  const dialog=gallery.querySelector('[data-ag-lightbox]');
  const toggle=dialog.querySelector('[data-ag-zoom-toggle]');
  const zoom=()=>{const expanded=dialog.classList.toggle('is-zoomed');toggle.textContent=expanded?'−':'+';toggle.setAttribute('aria-pressed',String(expanded))};
  gallery.querySelector('[data-ag-zoom-open]').addEventListener('click',()=>{
   if(!mobile())return;
   const source=main.querySelector('img'),target=dialog.querySelector('img');
   target.src=source.src;target.alt=source.alt;
   dialog.classList.remove('is-zoomed');toggle.textContent='+';toggle.setAttribute('aria-pressed','false');
   dialog.showModal();
  });
  dialog.querySelector('[data-ag-zoom-close]').addEventListener('click',()=>dialog.close());
  toggle.addEventListener('click',zoom);
  dialog.querySelector('img').addEventListener('dblclick',zoom);
  window.addEventListener('resize',()=>{if(!mobile()&&dialog.open)dialog.close()});
 });
})();
